<template lang='slm'>
#app
  .row.justify-content-md-center.no-gutters
    .col
      .container
        .row
          .col-12
            b-navbar#navbar toggleable="md" type="light"
              b-navbar-nav class="ml-auto"
                b-nav-item(v-on:click='setGlobalLocale(key)' v-for="(language, key) of languagesList" :key="key" right)
                  | {{ language.shortName }}
            router-view
    b-collapse.border-left.border-light.col-3.col-xs-1#sidebar
      .container.affix
        .row
          .col-12
            nav.navbar.navbar-light.navbar-expand-md.justify-content-end
              ul class="navbar-nav"
                li.nav-item
                  a.nav-link
                    font-awesome-icon :icon="['fas', 'cog']"
            .row
              .col-12
                | bz-editor-form
            .dropdown-divider
            .row
              .col-12
                ul.list-inline
                  li.list-inline-item
                    b-btn
                      font-awesome-icon :icon="['fas', 'paragraph']"
                  li.list-inline-item
                    b-btn
                      font-awesome-icon :icon="['fas', 'pencil-alt']"
            .dropdown-divider
            .row
              .col-12
                | bz-editor-asset-manager
        .row
          .col-12.controls
            b-button variant="success" {{ $t("forms.buttons.save") }}


</template>

<script>
import FontAwesomeIcon from '@/fontawesome'
import { routes } from '@/router'
import translations from '@/translations'
import { mapMutations } from 'vuex'

export default {
  name: 'app',
  data: function () {
    return {
      routes: routes
    }
  },
  components: {FontAwesomeIcon},
  computed: {
    languagesList () {
      return Object.entries(translations).reduce(
        (obj, [name, translation]) =>
          Object.assign(obj, {[name]: {shortName: translation.shortName, name: translation.name}}), {})
    }
  },
  methods: {
    ...mapMutations('localization', [ 'setGlobalLocale' ])
  }
}

</script>

<style lang='scss'>
@import 'node_modules/bootstrap/scss/bootstrap-reboot';

#app {
  font-family: "-apple-system",BlinkMacSystemFont,Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

@font-face {
  font-family: 'Open Sans Condensed Light';
  src: url('assets/fonts/OpenSansCondensed-Light.ttf');
}

h1.title {
  font-family: 'Open Sans Condensed Light', sans-serif;
}

#sidebar {
  background: $light;
}

#sidebar.collapsing {
  $sidebar-transition: width 0.01s ease !default;
  @include transition($sidebar-transition);
  height: auto !important;
}

#sidebar > .affix {
  position: sticky;
  top: 0;
}

$spasing: ($grid-gutter-width / 2);
#navbar {
  position: sticky;
  top: 0;
  z-index: 1000;
  background: white;
  margin-left: -$spasing;
  margin-right: -$spasing;
}

.no-gutters {
  margin-right: 0;
  margin-left: 0;

  > .col,
  > [class*="col-"] {
    padding-right: 0;
    padding-left: 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue